import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import { Grid, Icon, Popup } from 'semantic-ui-react';
import {
  LAST_5_MINUTES,
  LAST_15_MINUTES,
  LAST_30_MINUTES,
  LAST_HOUR,
  LAST_3_HOURS,
  LAST_6_HOURS,
  LAST_12_HOURS,
  LAST_24_HOURS,
  LAST_WEEK,
  LAST_MONTH,
  LAST_YEAR,
  TIME_RANGE_QUICK,
  TIME_RANGE_ABSOLUTE,
} from './Constants';
import { DATETIME_FORMAT } from '../constants';
import TimeRangeQuick from './components/timeRangeQuick';
import TimeRangeAbsolute from './components/timeRangeAbsolute';
import TimeRangeSelectionPanel from './components/timeRangeSelectionPanel';
// import UiIcon from '../uiIcon';
import polyglotUIComponents from '../i18n';
import { colorsModeUI } from '../modeUI';
import './index.css';

export {
  LAST_5_MINUTES,
  LAST_15_MINUTES,
  LAST_30_MINUTES,
  LAST_HOUR,
  LAST_3_HOURS,
  LAST_6_HOURS,
  LAST_12_HOURS,
  LAST_24_HOURS,
  LAST_WEEK,
  LAST_MONTH,
  LAST_YEAR,
  TIME_RANGE_QUICK,
  TIME_RANGE_ABSOLUTE,
};

/**
 * Time fram selection panel
 * Parameters (Props):
 * @param onChange: PropTypes.func
 * @param timeframe: PropTypes.number
 * @param nameButtonSend: PropTypes.string
 */
export default class TimeframeSelectionPanel extends React.PureComponent {
  constructor(props) {
    super(props);
    this.selectTimeFrameQuick = this.selectTimeFrameQuick.bind(this);
    this.selectTimeFrameAbsolute = this.selectTimeFrameAbsolute.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.toogleTimeRange = this.toogleTimeRange.bind(this);
    this.dateTimeMinMax = this.dateTimeMinMax.bind(this);
    this.polyglot = polyglotUIComponents(props.language);
    /* dateAbsoluteMin, dataAbsoluteMax */
    this.timeframes = {
      [LAST_5_MINUTES]: {
        name: this.polyglot.t('timeframe_selection_panel.last_5_minutes'),
        substract: 5,
        unit: 'minutes',
      },
      [LAST_15_MINUTES]: {
        name: this.polyglot.t('timeframe_selection_panel.last_15_minutes'),
        substract: 15,
        unit: 'minutes',
      },
      [LAST_30_MINUTES]: {
        name: this.polyglot.t('timeframe_selection_panel.last_30_minutes'),
        substract: 30,
        unit: 'minutes',
      },
      [LAST_HOUR]: {
        name: this.polyglot.t('timeframe_selection_panel.last_hour'),
        substract: 1,
        unit: 'hours',
      },
      [LAST_3_HOURS]: {
        name: this.polyglot.t('timeframe_selection_panel.last_3_hours'),
        substract: 3,
        unit: 'hours',
      },
      [LAST_6_HOURS]: {
        name: this.polyglot.t('timeframe_selection_panel.last_6_hours'),
        substract: 6,
        unit: 'hours',
      },
      [LAST_12_HOURS]: {
        name: this.polyglot.t('timeframe_selection_panel.last_12_hours'),
        substract: 12,
        unit: 'hours',
      },
      [LAST_24_HOURS]: {
        name: this.polyglot.t('timeframe_selection_panel.last_24_hours'),
        substract: 24,
        unit: 'hours',
      },
      [LAST_WEEK]: {
        name: this.polyglot.t('timeframe_selection_panel.last_week'),
        substract: 7,
        unit: 'days',
      },
      [LAST_MONTH]: {
        name: this.polyglot.t('timeframe_selection_panel.last_month'),
        substract: 1,
        unit: 'months',
      },
      [LAST_YEAR]: {
        name: this.polyglot.t('timeframe_selection_panel.last_year'),
        substract: 1,
        unit: 'years',
      },
    };
    const { dateTimeIniAbsolute, dateTimeEndAbsolute } = this.dateTimeMinMax(
      props.timeframe
    );
    this.state = {
      timeframe: props.timeframe,
      timeRange: TIME_RANGE_QUICK,
      openMenu: false,
      dateTimeIniAbsolute,
      dateTimeEndAbsolute,
    };
  }

  /**
   * Date time min max
   * this function returns the date time ini and the data time max (Moment object) for a time frame
   * @param number timeframe
   * @return object{Moment, Moment} : {dateTimeIni, dateTimeEnd}
   */
  dateTimeMinMax(timeframe) {
    const dateTimeEndAbsolute = Moment();
    const dateTimeIniAbsolute = Moment().subtract(
      this.timeframes[timeframe].substract,
      this.timeframes[timeframe].unit
    );

    return {
      dateTimeIniAbsolute,
      dateTimeEndAbsolute,
    };
  }

  /**
   * Select time frame quick
   * @param int timeframe
   */
  selectTimeFrameQuick(timeframe) {
    const { onChange } = this.props;
    const { dateTimeIniAbsolute, dateTimeEndAbsolute } =
      this.dateTimeMinMax(timeframe);
    this.setState({
      dateTimeIniAbsolute,
      dateTimeEndAbsolute,
      timeframe,
    });
    onChange(dateTimeIniAbsolute, dateTimeEndAbsolute);
    this.handleClose();
  }

  /**
   * Select time frame absolute
   * @param moment dateTimeIniAbsolute
   * @param moment dateTimeEndAbsolute
   */
  selectTimeFrameAbsolute(dateTimeIniAbsolute, dateTimeEndAbsolute) {
    const { onChange } = this.props;
    this.setState({
      dateTimeIniAbsolute,
      dateTimeEndAbsolute,
    });
    onChange(dateTimeIniAbsolute, dateTimeEndAbsolute);
    this.handleClose();
  }

  /**
   * Handle open
   */
  handleOpen() {
    this.setState({ openMenu: true });
  }

  /**
   * Handle close
   */
  handleClose() {
    this.setState({ openMenu: false });
  }

  /**
   * Toogle time range
   * @param int timeRange
   */
  toogleTimeRange(timeRange) {
    if (timeRange === TIME_RANGE_ABSOLUTE) {
      /* per default show 60 days  */
      const { dateTimeIniAbsolute, dateTimeEndAbsolute } =
        this.dateTimeMinMax(LAST_MONTH);

      this.setState({
        dateTimeIniAbsolute,
        dateTimeEndAbsolute,
        timeRange,
      });
    } else {
      this.setState({
        timeRange,
      });
    }
  }

  render() {
    const {
      timeframe,
      openMenu,
      timeRange,
      dateTimeIniAbsolute,
      dateTimeEndAbsolute,
    } = this.state;
    const { nameButtonSend, mode, language } = this.props;
    const timeFrameSelected =
      timeRange === TIME_RANGE_QUICK
        ? this.timeframes[timeframe].name
        : `${this.polyglot.t('general.from')}: ${dateTimeIniAbsolute.format(
            DATETIME_FORMAT
          )} ${this.polyglot.t('general.to')}: ${dateTimeEndAbsolute.format(
            DATETIME_FORMAT
          )}`;
    const style = { padding: '0.2rem' };
    if (mode !== null) {
      const modeColors = colorsModeUI(mode);
      style.backgroundColor = modeColors.POPUP_MAIN_MENU_BACKGROUND;
      style.color = modeColors.POPUP_MAIN_MENU_COLOR;
      style.boxShadow = modeColors.POPUP_SHADOW;
      style.borderWidth = '1px';
    }
    return (
      <Popup
        flowing
        basic
        position="bottom left"
        on="click"
        onClose={this.handleClose}
        onOpen={this.handleOpen}
        trigger={
          <div className="timeframe-selected">
            <Icon name="clock outline" />
            {timeFrameSelected}
          </div>
        }
        open={openMenu}
      >
        <Grid stackable style={style}>
          <TimeRangeSelectionPanel
            toogleTimeRange={this.toogleTimeRange}
            timeRange={timeRange}
            mode={mode}
            language={language}
          />
          {timeRange === TIME_RANGE_QUICK ? (
            <TimeRangeQuick
              timeframes={this.timeframes}
              selectTimeFrame={this.selectTimeFrameQuick}
            />
          ) : (
            <TimeRangeAbsolute
              nameButtonSend={
                nameButtonSend !== null
                  ? nameButtonSend
                  : this.polyglot.t('button.send')
              }
              dateTimeIniAbsolute={dateTimeIniAbsolute}
              dateTimeEndAbsolute={dateTimeEndAbsolute}
              selectTimeFrame={this.selectTimeFrameAbsolute}
              mode={mode}
              language={language}
            />
          )}
        </Grid>
      </Popup>
    );
  }
}

TimeframeSelectionPanel.propTypes = {
  onChange: PropTypes.func,
  timeframe: PropTypes.number,
  nameButtonSend: PropTypes.string,
  mode: PropTypes.string,
  language: PropTypes.string,
};

TimeframeSelectionPanel.defaultProps = {
  timeframe: LAST_15_MINUTES,
  onChange: () => {},
  nameButtonSend: null,
  mode: null,
  language: null,
};
